export const VerifyAddress = `
    mutation ($address: String!) {
      verifyAddress (address: $address) {
        isValid
        zip
        serviceable
        serviceAreaLabel
      }
    }
 `;
